// Re-export all data from the organized structure
export * from './data/index';
